import React, { Component } from 'react';
import './css/App.css';
// import "./css/bootstrap-asu.css";
import './css/Autosuggest.css';
import UtilFunctions from './UtilFunctions';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import Jumbotron from "react-bootstrap/Jumbotron";
import Form from 'react-bootstrap/Form';
import { Route, Link } from 'react-router-dom';
import ClassResults from './ClassResults';
import isEmpty from 'lodash.isempty';
import { GAEvent } from './analytics';
// import Header from "./components/Header";
// import Footer from "./components/Footer";
import HomeSearch from './HomeSearch';
import queryString from 'query-string';
import serviceauth from './auth/serviceauth';
import Background from './images/class-search-background.png';
import archivesBackground from './images/class-search-archives-background.png';
// import Accordion from 'react-bootstrap/Accordion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faBell, faTimes } from '@fortawesome/free-solid-svg-icons';
// import Button from "react-bootstrap/Button";
import Autosuggestions from './components/Autosuggestions';
import { Spinner, spinnerService } from '@simply007org/react-spinners';
import SpinnerImage from 'react-bootstrap/Spinner';
import './css/ResultsTable.css';
import Header from './components/Header';
import Footer from './components/Footer';
import BrowseBySubject from './components/BrowseBySubject';
import ClassBanner from './components/ClassBanner';

const jumbotronBackground = {
  backgroundPosition: '0% 68%',
  backgroundSize: 'cover',
  background:
    'linear-gradient(to top, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0)), url(' +
    Background +
    ')',
};
const jumbotronArchivesBackground = {
  backgroundPosition: '0% 68%',
  backgroundSize: 'cover',
  background:
    'linear-gradient(to top, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0)), url(' +
    archivesBackground +
    ')',
};

const ENV = process.env.REACT_APP_HOST_ENV;

class Search extends Component {
  constructor(props) {
    super(props);

    // var crypto = require('crypto');

    // var hash = crypto.createHash('sha256');

    this.state = {
      term: '',
      termList: [],
      fullTermList: [],
      showArchive: false,
      subject: '',
      catalogNbr: '',
      searchType: 'all',
      keywords: '',
      college: '',
      campus: [],
      campusOrOnlineSelection: 'A',
      session: [],
      gs: [],
      instructor: '',
      level: '',
      classNbr: '',
      promod: false,
      honors: false,
      daysOfWeek: [],
      startDate: '',
      endDate: '',
      startTime: '',
      endTime: '',
      advancedSearchOpen: localStorage.getItem('classAdvancedSearchOpen'),
      navTree: [],
      showBanner1: 'N',
      banner1: null,
      showBanner2: 'N',
      banner2: null,
      turnOffApp: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.pushToHistory = this.pushToHistory.bind(this);
    this.handleDateTimeChange = this.handleDateTimeChange.bind(this);
    this.handleOpenAdvancedSearch = this.handleOpenAdvancedSearch.bind(this);
    this.handleTermChange = this.handleTermChange.bind(this);
    this.trackSearchFieldsEntered = this.trackSearchFieldsEntered.bind(this);
    this.handlePushToHistoryFromHomeSearch =
      this.handlePushToHistoryFromHomeSearch.bind(this);
    this.getSearchBySubjectURL = this.getSearchBySubjectURL.bind(this);

    this.oldClassSearchUrlNonProd =
      'https://webapp4-' + ENV + '.asu.edu/catalog';
    this.oldClassSearchUrlProd = 'https://webapp4.asu.edu/catalog';
  }

  async componentDidMount() {
    // console.log("componentDidMount")
    //update fields from url
    //const data = UtilFunctions.parseUrl(this.props.location.search)
    //const url = 'http://localhost:5000/course-catalog/api/v1/search/terms';

    window.document.title = 'Class Search | Arizona State University';

    const appSettings = await UtilFunctions.getAppSettings();

    let banner1Array = ['', '', '', '', ''];
    try {
      // Try to parse as JSON first
      try {
        // Banner text should be stored as a JSON array with 5 elements:
        // [0]: The banner HTML content (e.g. "<h4>Help us improve your experience!</h4><p>We're adding new features...</p>")
        // [1]: Button label text (e.g. "Take the survey here")
        // [2]: Button URL (e.g. "http://www.google.com")
        // [3]: Show close button ("Y" or "N")
        // [4]: Banner color class (e.g. "badge-info")
        const parsedArray = JSON.parse(appSettings.get('banner_text'));
        if (Array.isArray(parsedArray)) {
          // If successfully parsed as array, use it (up to 5 elements)
          for (let i = 0; i < Math.min(parsedArray.length, 5); i++) {
            banner1Array[i] = parsedArray[i];
          }
        }
      } catch (jsonError) {
        // If it's not valid JSON, just use it as a string
        banner1Array[0] = appSettings.get('banner_text');
      }
    } catch (e) {
      console.error(e);
    }
    if (
      (appSettings !== null &&
        appSettings.get('system_enabled') !== null &&
        appSettings.get('system_enabled') === 'N') ||
      appSettings == null
    ) {
      //turn off app
      this.setState({
        turnOffApp: true,
      });
    } else {
      fetch(serviceauth.getRequestObject(UtilFunctions.getTermListUrl(), 'GET'))
        .then((response) => {
          if (response.status === 401) {
            serviceauth.reauth();
          }
          return response.json();
        })
        .then(async (termList) => {
          //update fields from url

          const data = UtilFunctions.parseUrl(this.props.location.search);
          const term = isEmpty(data.term)
            ? [termList.currentTerm[0].value]
            : [data.term];
          // console.log(termList.currentTerm[0].value)
          // console.log(termList.currentTerm[0].value)
          //  const subjectsList = await getSubjectsList(this.state.term);
          // console.log(subjectsList)
          var showArchiveBool = UtilFunctions.showArchive(
            term[0],
            termList.fullList
          );
          var pastTermList = UtilFunctions.getPastTermList(termList.fullList);
          var currentTermList = UtilFunctions.getCurrentTermList(
            termList.fullList
          );
          this.setState({
            term: term,
            termList: showArchiveBool ? pastTermList : currentTermList,
            firstPastTerm: pastTermList[0].value,
            fullTermList: termList.fullList,
            showArchive: showArchiveBool,
            subject: isEmpty(data.subject) ? '' : data.subject,
            catalogNbr: isEmpty(data.catalogNbr) ? '' : data.catalogNbr,
            searchType: isEmpty(data.searchType) ? 'all' : data.searchType,
            keywords: isEmpty(data.keywords) ? '' : data.keywords,
            // college: isEmpty(data.college ) ?  undefined : data.college ,
            //campus: isEmpty(data.campus ) ?  undefined : data.campus.join(","),
            //session: isEmpty(data.session ) ?  undefined : data.session.join(",") ,
            // campusOrOnlineSelection: isEmpty(data.campusOrOnlineSelection ) ?  "C" : data.campusOrOnlineSelection,
            // gen_studies:isEmpty(data.gs ) ? undefined : data.gs.join(",") ,
            instructor: isEmpty(data.instructorName) ? '' : data.instructorName,
            // level: isEmpty(data.level ) ? undefined : data.level ,
            classNbr: isEmpty(data.classNbr) ? '' : data.classNbr,
            // promod: data.promod  ,
            // hon : data.honors  ,
            // honorsEnrichmentContracts: data.honors ? false : undefined,
            // units: isEmpty(data.units ) ? undefined : data.units ,
            // daysOfWeek: isEmpty(data.daysOfWeek)
            //   ? []
            //   : data.daysOfWeek.split(","),
            navTree: await UtilFunctions.getHeaderNavTree(term, 'classes'),
            showBanner1: appSettings.get('banner_status'),
            banner1: banner1Array[0],
            banner1Link: banner1Array[2] !== '' ? banner1Array[2] : undefined,
            banner1LinkLabel: banner1Array[1],
            banner1ColorClass: banner1Array[4],
            banner1CloseButton: banner1Array[3] === 'Y',
            showBanner2: appSettings.get('banner_status_2'),
            banner2: appSettings.get('banner_text_2'),
            // startDate: isEmpty(data.startDate ) ? undefined : data.startDate ,
            // endDate: isEmpty(data.endDate ) ? undefined : data.endDate ,
            // startTime: isEmpty(data.startTime ) ? undefined : data.startTime ,
            // endTime: isEmpty(data.endTime ) ? undefined : data.endTime ,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  // componentDidUpdate(){
  //   //this is needed so that a subject is entered in the subject field when using Browse by Subject
  //   const data = UtilFunctions.parseUrl(this.props.location.search);
  //   if(data && data.subject && this.state.subject !== data.subject){
  //     this.setState({
  //       subject: isEmpty(data.subject) ? "" : data.subject,
  //     });
  //   }
  // }

  handleChange(event, checkedItems) {
    const type = event.target.type;
    var name = event.target.name;
    // Ensure single declaration of val for checkbox handling to satisfy linter
    let val;

    //console.log(checkedItems)

    if (type === 'radio' || type.indexOf('select') >= 0) {
      this.setState({ [name]: event.target.value }, () => {
        this.pushToHistory();
      });
    } else if (type === 'checkbox') {
      val = [];
      if (checkedItems !== null) {
        //multiple select
        checkedItems.forEach((value, key) => {
          //console.log()
          if (value) {
            //val.push(key);
            val.push(value.value);
          }
        });
      } else {
        //regular checkbox
        val = event.target.checked;
      }

      this.setState(
        {
          [name]: val,
        },
        () => {
          // console.log("after state update")
          this.pushToHistory();
        }
      );
    } else {
      var value = event.target.value;
      if (name === 'subject' || name === 'catalogNbr')
        value = value.toUpperCase();
      this.setState({ [name]: value });
    }
  }

  trackSearchFieldsEntered() {
    const { subject, catalogNbr, keywords } = this.state;
    if (subject) GAEvent('Class Search', 'Subject Entered', subject);
    if (catalogNbr) GAEvent('Class Search', 'Class Number Entered', catalogNbr);
    if (keywords) GAEvent('Class Search', 'Keyword Search Entered', keywords);
  }

  handleDateTimeChange(type, start, end) {
    if (type === 'date') {
      this.setState(
        {
          startDate: start == null ? '' : start.toLocaleDateString(),
          endDate: end == null ? '' : end.toLocaleDateString(),
        },
        () => {
          // console.log("pushing history date " + this.state.startDate)
          this.pushToHistory();
        }
      );
    } else {
      this.setState(
        {
          startTime: start == null ? '' : start.toTimeString().split(' ')[0],
          endTime: end == null ? '' : end.toTimeString().split(' ')[0],
        },
        () => {
          this.pushToHistory();
        }
      );
    }
  }

  handleKeyDown(event) {
    if (event.keyCode === 13) {
      this.trackSearchFieldsEntered();
      this.pushToHistory();
    }
  }

  handleButtonClick() {
    GAEvent('Class Search', 'Search Classes button click');
    this.trackSearchFieldsEntered();
    this.pushToHistory();
  }

  handleOpenAdvancedSearch() {
    var open =
      localStorage.getItem('classAdvancedSearchOpen') === null ||
      localStorage.getItem('classAdvancedSearchOpen') === 'false'
        ? 'true'
        : 'false';

    localStorage.setItem('classAdvancedSearchOpen', open);
  }

  handleTermChange(e) {
    const selectedLabel =
      e.target.options[e.target.selectedIndex]?.text || '';
    GAEvent('Class Search', 'Term selected', selectedLabel);

    var showArchiveBool = UtilFunctions.showArchive(
      e.target.value,
      this.state.fullTermList
    );
    this.setState({
      term: e.target.value,
      termList: showArchiveBool
        ? UtilFunctions.getPastTermList(this.state.fullTermList)
        : UtilFunctions.getCurrentTermList(this.state.fullTermList),
      showArchive: showArchiveBool,
    });
    this.props.history.push(this.props.match.path + '?term=' + e.target.value);
  }

  getSearchBySubjectURL(subject) {
    const filters = {
      subject: subject,
      term: this.state.term,
    };

    return (
      this.props.match.path +
      '/classlist?' +
      UtilFunctions.getQueryStringFromState(filters)
    );
  }

  pushToHistory() {
    spinnerService.show('mySpinner');
    const newUrl =
      this.props.match.path +
      '/classlist?' +
      UtilFunctions.getQueryStringFromState(this.state);
    if (this.props.location.pathname + this.props.location.search === newUrl) {
      //cscc-238 Show spinner when searching again
      setTimeout(() => {
        spinnerService.hide('mySpinner');
      }, 1000);
    } else {
      this.props.history.push(newUrl);
    }
  }

  handlePushToHistoryFromHomeSearch(filters, url) {
    // console.log(filters)
    if (url) {
      this.props.history.push(url);
    } else {
      spinnerService.show('mySpinner');
      this.props.history.push(
        this.props.match.path +
          '/classlist?' +
          UtilFunctions.getQueryStringFromState(filters)
      );
    }
  }

  render() {
    // console.log("serviceauth.SS_NAME: "+sessionStorage.getItem(serviceauth.SS_NAME));
    // console.log("serviceauth.SS_JWT_TOKEN: "+sessionStorage.getItem(serviceauth.SS_JWT_TOKEN));
    const parsedQueryString = queryString.parse(this.props.location.search);
    const queryStringCount = Object.keys(parsedQueryString).length;
    const showHomeSearch =
      queryStringCount === 0 ||
      (queryStringCount === 1 && parsedQueryString.term !== undefined);

    //  console.log("showing view as: "+sessionStorage.getItem(serviceauth.SS_VIEW_AS))
    return (
      <React.Fragment>
        {this.state.turnOffApp && <Container>App is Down</Container>}
        {!this.state.turnOffApp && (
          <Container fluid={true} className="p-0">
            <Header navTree={this.state.navTree} />
            {/* <Header
              title="Class Search"
              navTree={this.state.navTree}
              loginLink={serviceauth.redirectToServiceauthUrl(true)}
              loggedIn={sessionStorage.getItem(serviceauth.SS_NAME) && sessionStorage.getItem(serviceauth.SS_JWT_TOKEN)}
              userName={sessionStorage.getItem(serviceauth.SS_NAME)}
              logoutLink="/logout"


            /> */}

            {/* <a id="skip-to-content" className="anchor" href="https://catalog.apps.asu.edu/catalog/classes">a</a> */}
            {/* <div id="beta_toggle_bar">
              <div id="beta_toggle_bar_container">
                <div className="row">
                  <div className="col-md-8 beta_toggle_text pb-2 pt-2">

                  Help us improve Class Search! Share your feedback with a quick <a href="https://asu.questionpro.com/a/TakeSurvey?tt=5JQAANO2628ECHrPeIW9eQ%3D%3D" tabIndex={0} >survey</a>.
                  </div> */}

            {/* <div className="col-md-4 beta_toggle_toggle">
                    <table>
                      <tbody>
                        <tr>
                          <td className="beta_label">
                            Beta Class Search
                          </td>
                          <td>
                            <label className="switch1">
                              {ENV !== null && ENV !== 'prod' ? (
                                <a className="slider1 round" href={this.oldClassSearchUrlNonProd} tabIndex={0}><div className="beta_toggle">On</div></a>
                              ) : (
                                <a className="slider1 round" href={this.oldClassSearchUrlProd} tabIndex={0}><div className="beta_toggle">On</div></a>
                              )}

                              <input type="checkbox" tabIndex={-1} />
                            </label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div> */}
            {/* </div>
              </div>
            </div> */}
            {this.state.showBanner1 === 'Y' && (
              <aside aria-label="Site announcement banner" role="banner">
                <div className="row g-0" id="banner">
                  <div
                    className={`col uds-full-width ${this.state.banner1ColorClass} `}
                  >
                    <section className="" aria-label="Announcement banner">
                      <div
                        className="banner  pb-3 uds-content-align"
                        role="banner"
                      >
                        <div className="banner-icon">
                          <FontAwesomeIcon
                            icon={faBell}
                            className="me-2"
                            title="Banner"
                            aria-hidden="true"
                          />
                        </div>

                        <div className="banner-content">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: this.state.banner1,
                            }}
                          />
                        </div>
                        {this.state.banner1Link && (
                          <div className="banner-buttons">
                            <div className="container-fluid">
                              <div className="col col-sm-12 ">
                                <a
                                  className="btn btn-dark btn-md"
                                  href={this.state.banner1Link}
                                  target="_blank"
                                  data-ga="Link Button"
                                  data-ga-name="onclick"
                                  data-ga-event="link"
                                  data-ga-action="click"
                                  data-ga-type="external link"
                                  data-ga-region="main content"
                                  data-ga-section="banner"
                                  rel="noreferrer"
                                  aria-label={`${this.state.banner1LinkLabel} (opens in new tab)`}
                                >
                                  {this.state.banner1LinkLabel}
                                </a>
                              </div>
                            </div>
                          </div>
                        )}
                        {this.state.banner1CloseButton && (
                          <div className="banner-close">
                            <button
                              aria-label="Close announcement banner"
                              type="button"
                              className="btn btn-circle btn-circle-alt-black close"
                              onClick={() => {
                                document.querySelector(
                                  '.badge-info'
                                ).style.display = 'none';
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faTimes}
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        )}
                      </div>
                    </section>
                  </div>
                </div>
              </aside>
            )}

            <main role="main">
              <section
                style={
                  this.state.showArchive
                    ? jumbotronArchivesBackground
                    : jumbotronBackground
                }
                className="mb-0 pt-5 pb-5"
                id="main"
                aria-label="Class search form"
              >
                {sessionStorage.getItem(serviceauth.SS_VIEW_AS) === 'Y' && (
                  <div
                    className=" alert-warning container"
                    role="alert"
                    aria-live="polite"
                  >
                    <p>
                      You are viewing as user:{' '}
                      {sessionStorage.getItem(serviceauth.SS_VIEW_AS_USER)}
                    </p>
                    {sessionStorage.getItem(serviceauth.SS_IS_STUDENT) ===
                      'Y' &&
                      sessionStorage.getItem(serviceauth.SS_IS_ONLINE) ===
                        'Y' && (
                        <p>
                          {sessionStorage.getItem(serviceauth.SS_VIEW_AS_USER)}{' '}
                          is an ONLINE student
                        </p>
                      )}
                    {sessionStorage.getItem(serviceauth.SS_IS_STUDENT) ===
                      'Y' &&
                      sessionStorage.getItem(serviceauth.SS_IS_ONLINE) ===
                        'N' && (
                        <p>
                          {sessionStorage.getItem(serviceauth.SS_VIEW_AS_USER)}{' '}
                          is NOT an ONLINE student
                        </p>
                      )}
                    <p>
                      AcadCareer:{' '}
                      {sessionStorage.getItem(serviceauth.SS_CAREER)}
                    </p>
                    <p>
                      Staff:
                      {sessionStorage.getItem(serviceauth.SS_IS_STAFF) ===
                        'Y' && ' Yes'}
                      {sessionStorage.getItem(serviceauth.SS_IS_STAFF) ===
                        'N' && ' No'}
                    </p>
                  </div>
                )}

                <Container>
                  <Row>
                    <Col xs={'auto'} className="p-0">
                      <h1 className=" mt-0" id="skip-to-content">
                        <span className="highlight-white">
                          {this.state.showArchive && 'Class Search Archives'}
                          {!this.state.showArchive && 'Class Search'}
                        </span>
                      </h1>
                      {this.state.showArchive && (
                        <a className="white mt-2" href="/catalog/classes">
                          Return to current class search
                        </a>
                      )}
                    </Col>
                  </Row>

                  <div role="search" aria-label="Search for classes">
                    <Row className="mt-md-1 mt-lg-4 align-items-center white-box p-3">
                      <Col lg="2" className="p-0 pt-lg-0 pt-2">
                        <Form.Group className="mb-0" controlId="term">
                          <Form.Label>Term</Form.Label>
                          <Form.Control
                            as="select"
                            className="asu form-control form-select"
                            onChange={this.handleTermChange}
                            usevalueaslabel="false"
                            id="term"
                            closemenuonselect="true"
                            isclearable="false"
                            value={this.state.term}
                            tabIndex={0}
                            aria-label="Select Term"
                            placeholder="Select Term"
                            aria-describedby="term-help"
                          >
                            {this.state.termList !== null &&
                            this.state.termList.length > 0 ? (
                              this.state.termList.map((term) => (
                                <option value={term.value} key={term.value}>
                                  {term.label}
                                </option>
                              ))
                            ) : (
                              <option value="" key="fallback">
                                Terms
                              </option>
                            )}
                            {!this.state.showArchive &&
                              this.state.firstPastTerm && (
                                <option
                                  value={this.state.firstPastTerm}
                                  key="previous-terms"
                                >
                                  Previous Terms
                                </option>
                              )}
                          </Form.Control>
                          <div id="term-help" className="visually-hidden">
                            Select the academic term to search for classes
                          </div>
                        </Form.Group>
                      </Col>
                      <Col
                        lg="1"
                        xs="6"
                        className="p-0 pe-1 pe-lg-0 pt-lg-0 pt-2"
                      >
                        <Form.Group className="mb-0" controlId="subject">
                          <Form.Label id="subject-label" htmlFor="subject">
                            Subject
                          </Form.Label>
                          <Autosuggestions
                            term={this.state.term}
                            name="subject"
                            onChange={this.handleChange}
                            onKeyDown={this.handleKeyDown}
                            value={this.state.subject}
                            className="asu form-control"
                            id="subject"
                            placeholder="Subject"
                            aria-describedby="subject-help"
                            aria-labelledby="subject-label"
                          />
                          <div id="subject-help" className="visually-hidden">
                            Enter the subject code (e.g., CSE, ENG, MAT)
                          </div>
                        </Form.Group>
                      </Col>
                      <Col lg="1" xs="6" className="p-0 pt-lg-0 pt-2">
                        <Form.Group className=" mb-0" controlId="catalogNbr">
                          <Form.Label>Number</Form.Label>
                          <Form.Control
                            type="text"
                            inputMode="numeric"
                            pattern="\d*"
                            placeholder="Number"
                            onChange={this.handleChange}
                            onKeyDown={this.handleKeyDown}
                            name="catalogNbr"
                            value={this.state.catalogNbr}
                            className="asu"
                            id="catalogNbr"
                            aria-label="Course number"
                            aria-describedby="catalogNbr-help"
                          />
                          <div id="catalogNbr-help" className="visually-hidden">
                            Enter the course number (e.g., 101, 205)
                          </div>
                        </Form.Group>
                      </Col>
                      <Col lg="3" className="p-0 pt-lg-0 pt-2 ">
                        <Form.Group className=" mb-0" controlId="keyword">
                          <Form.Label>Keyword search</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter keywords"
                            onChange={this.handleChange}
                            onKeyDown={this.handleKeyDown}
                            name="keywords"
                            className="asu form-control"
                            value={this.state.keywords}
                            id="keyword"
                            aria-label="Search by keyword"
                            aria-describedby="keyword-help"
                          />
                          <div id="keyword-help" className="visually-hidden">
                            Enter keywords to search in course titles and
                            descriptions
                          </div>
                        </Form.Group>
                      </Col>
                      <Col className="p-0   mt-3 ">
                        <button
                          id="search-button"
                          type="button"
                          className="btn btn-gold ms-lg-2"
                          onClick={this.handleButtonClick}
                          aria-describedby="search-button-help"
                        >
                          <FontAwesomeIcon
                            icon={faSearch}
                            className="me-2"
                            aria-hidden="true"
                          />
                          Search Classes
                        </button>
                        <div
                          id="search-button-help"
                          className="visually-hidden"
                        >
                          Click to search for classes with the specified
                          criteria
                        </div>
                      </Col>
                      <Col className="pt-3 ps-md-2 ">
                        <Link
                          to={{
                            pathname: '/catalog/advanced',
                            search: this.props.location.search,
                          }}
                          onClick={() =>
                            GAEvent('Class Search', 'Advanced Search link click')
                          }
                          aria-label="Go to advanced search page with additional filter options"
                        >
                          <span className="text-nowrap">
                            {this.props.location.search.indexOf(
                              'advanced=true'
                            ) >= 0 && 'Continue Advanced Search'}
                            {this.props.location.search.indexOf(
                              'advanced=true'
                            ) < 0 && 'Advanced Search'}
                          </span>
                        </Link>
                      </Col>
                    </Row>
                  </div>
                </Container>
              </section>

              {/* <Route exact path="/catalog/classes/classlist" >


              </Route> */}
              {/*Insert Second Banner here*/}
              {this.state.showBanner2 === 'Y' && (
                <aside aria-label="Secondary announcement banner">
                  <ClassBanner
                    bannerColor="gray"
                    bannerHtml={this.state.banner2}
                  ></ClassBanner>
                </aside>
              )}

              <section aria-label="Class search results and navigation">
                {showHomeSearch && (
                  <Route exact path="/catalog/classes">
                    <HomeSearch
                      term={this.state.term}
                      path={this.props.match.path}
                    />
                  </Route>
                )}
                {showHomeSearch && (
                  <Route exact path="/catalog/classes/classlist">
                    <HomeSearch
                      term={this.state.term}
                      path={this.props.match.path}
                    />
                  </Route>
                )}
                <Route
                  path="/catalog/classes/classlist"
                  component={ClassResults}
                />
                <Route
                  exact
                  path="/catalog/classes/classlist/browsebysubject"
                  render={() => (
                    <BrowseBySubject
                      searchBySubjectURL={this.getSearchBySubjectURL}
                      term={this.state.term}
                    />
                  )}
                />
              </section>
            </main>

            <Footer />
            <aside
              aria-label="Loading indicator"
              aria-live="polite"
              role="status"
            >
              <span className="spinner-span">
                <Spinner name="mySpinner">
                  <div
                    className="spinner-button mt-5 spinner-button-styles"
                    role="status"
                    aria-live="polite"
                    aria-atomic="true"
                  >
                    <SpinnerImage
                      as="span"
                      animation="grow"
                      size="sm"
                      aria-hidden="true"
                      className="me-2"
                    />
                    <span>Loading …</span>
                  </div>
                </Spinner>
              </span>
            </aside>
          </Container>
        )}
      </React.Fragment>
    );
  }
}

export default Search;
